import { ComposeViewState, ComposeOperation, GroupComposeViewState } from 'owa-mail-compose-store';
import getRecipientsCount from './getRecipientsCount';

export function isViewStateDirty(context: ComposeViewState): boolean {
    return (
        context.isDirty ||
        (context.toRecipientWell && context.toRecipientWell.isDirty) ||
        (context.ccRecipientWell && context.ccRecipientWell.isDirty) ||
        (context.bccRecipientWell && context.bccRecipientWell.isDirty)
    );
}

export function getTotalRecipientCount(context: ComposeViewState): number {
    return (
        getRecipientsCount(context.toRecipientWell) +
        getRecipientsCount(context.ccRecipientWell) +
        getRecipientsCount(context.bccRecipientWell)
    );
}

export function isGroupScenario(
    viewState: ComposeViewState | GroupComposeViewState
): viewState is GroupComposeViewState {
    return (
        isGroupComposeViewState(viewState) &&
        viewStateHasGroupIdAsRecipient(<GroupComposeViewState>viewState)
    );
}

/* Group may have been removed from recipients since creating a group compose view state.
Check to see if the view state still contains the group as a recipient */
function viewStateHasGroupIdAsRecipient(groupComposeViewState: GroupComposeViewState) {
    // Short circuit this evaluation by first checking for Reply All operation,
    // since group cannot be removed from recipients in that scenario
    return (
        groupComposeViewState.operation == ComposeOperation.ReplyAll ||
        groupComposeViewState.toRecipientWell.recipients.some(recipient => {
            return (
                recipient.persona.EmailAddress.EmailAddress.toLowerCase() ===
                groupComposeViewState.groupId.toLowerCase()
            );
        })
    );
}

function isGroupComposeViewState(
    viewState: ComposeViewState | GroupComposeViewState
): viewState is GroupComposeViewState {
    return !!(<GroupComposeViewState>viewState).groupId;
}
